import React from "react";
import { Badge } from "@/components/ui/badge";
import { APP_STATUS, INST_STATUS, DOC_STATUS } from "@/lib/status";

const MAPS = { app: APP_STATUS, inst: INST_STATUS, doc: DOC_STATUS };
const PARCIAL_VENCIDA = { label: "Parcial · vencida", cls: "bg-red-50 text-red-700 border-red-200" };
const hojeISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export const StatusBadge = ({ status, type = "app", testid, vencimento }) => {
  const map = MAPS[type] || APP_STATUS;
  let s = map[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  if (type === "inst" && status === "parcial" && vencimento && String(vencimento).slice(0, 10) < hojeISO()) s = PARCIAL_VENCIDA;
  return (
    <Badge data-testid={testid} variant="outline" className={`font-medium ${s.cls}`}>
      {s.label}
    </Badge>
  );
};
